import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { VariantGroup } from '../../types/product';
import { formatPrice } from '../../utils/currency';
interface Props {
  group: VariantGroup;
  value: string;
  onChange: (optionId: string) => void;
  hideLegend?: boolean;
}
function delta(n: number) {
  return n > 0 ? `+${formatPrice(n)}` : n < 0 ? `−${formatPrice(-n)}` : '';
}
export function VariantSelector({
  group,
  value,
  onChange,
  hideLegend = false
}: Props) {
  const selected = group.options.find(o => o.id === value);
  return <fieldset data-id="element-590" data-mp="1t4gx0v1uw1at">
      {!hideLegend && <legend className="mb-2.5 text-sm text-muted" data-id="element-591" data-mp="1ocgt6rio0o8y">
          {group.name}: <span className="font-semibold text-ink" data-id="element-592" data-mp="1oam6b7nu2m28">{selected?.label}</span>
        </legend>}

      {group.kind === 'swatch' && <div className="flex gap-2.5" data-id="element-593" data-mp="2gtjf240ejw5u">
          {group.options.map(o => {
        const active = o.id === value;
        return <label key={o.id} className="cursor-pointer" title={o.label} data-id="element-594" data-mp="2c18fx3dhkeec">
                <input type="radio" name={group.id} value={o.id} checked={active} onChange={() => onChange(o.id)} className="peer sr-only" data-id="element-595" data-mp="29936vg93da4w" />
                <span className={`block h-9 w-9 rounded-full ring-offset-2 transition-shadow duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-ink/40 ${active ? 'ring-2 ring-ink' : 'ring-1 ring-ink/15 hover:ring-ink/40'}`} style={{
            backgroundColor: o.swatch
          }} data-id="element-596" data-mp="2e8o7rw7tnsk9" />
                <span className="sr-only" data-id="element-597" data-mp="1ukfgdoe3rqlt">{o.label}</span>
              </label>;
      })}
        </div>}

      {group.kind === 'pill' && <div className="flex flex-wrap gap-2" data-id="element-598" data-mp="1lho5bpp52wup">
          {group.options.map(o => {
        const active = o.id === value;
        return <label key={o.id} className="cursor-pointer" data-id="element-599" data-mp="3av1afh52sowv">
                <input type="radio" name={group.id} value={o.id} checked={active} onChange={() => onChange(o.id)} className="peer sr-only" data-id="element-600" data-mp="3fv5ufh5701ru" />
                <span className={`flex h-10 items-center gap-2 whitespace-nowrap rounded-lg border px-3.5 text-sm font-medium transition-colors duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-ink/30 ${active ? 'border-ink bg-ink text-white' : 'border-line bg-white text-ink hover:border-ink/40'}`} data-id="element-601" data-mp="3ecyruy78jqak">
                  {o.label}
                  {o.priceDelta !== 0 && <span className={`text-xs ${active ? 'text-white/70' : 'text-muted'}`} data-id="element-602" data-mp="3s7re0fhms4q4">{delta(o.priceDelta)}</span>}
                </span>
              </label>;
      })}
        </div>}

      {group.kind === 'card' && <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-603" data-mp="jqd4ifgmvidb">
          {group.options.map(o => {
        const active = o.id === value;
        return <label key={o.id} className="cursor-pointer" data-id="element-604" data-mp="eylmitbjmkys">
                <input type="radio" name={group.id} value={o.id} checked={active} onChange={() => onChange(o.id)} className="peer sr-only" data-id="element-605" data-mp="n9c40ky886i8" />
                <span className={`flex h-full items-start gap-3 rounded-xl border p-4 transition-colors duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-ink/30 ${active ? 'border-ink bg-white' : 'border-line bg-white hover:border-ink/30'}`} data-id="element-606" data-mp="rc8iq0knbigw">
                  <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${active ? 'border-ink bg-ink' : 'border-ink/25'}`} aria-hidden="true" data-id="element-607" data-mp="1a8ryv9tva6my">
                    {active && <CheckIcon className="h-3 w-3 text-volt" strokeWidth={3} data-id="element-608" data-mp="1oy690k59os3e" />}
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-609" data-mp="1twhhorjtswk1">
                    <span className="flex items-baseline justify-between gap-2" data-id="element-610" data-mp="1tx90f1sbqzsw">
                      <span className="text-sm font-semibold text-ink" data-id="element-611" data-mp="2qn32rf93tnqj">{o.label}</span>
                      <span className="shrink-0 text-xs font-medium text-muted" data-id="element-612" data-mp="2lo9rlthai8tj">{o.priceDelta === 0 ? 'Inbegrepen' : delta(o.priceDelta)}</span>
                    </span>
                    {o.detail && <span className="mt-0.5 block text-xs text-muted" data-id="element-613" data-mp="2vekx3kgmgq2j">{o.detail}</span>}
                  </span>
                </span>
              </label>;
      })}
        </div>}
    </fieldset>;
}